import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom'
import DashboardHeader from '../shared/components/DashboardHeader';
import SideMenu from '../shared/components/SideMenu';
import Footer from '../shared/components/Footer';
import Moment from 'react-moment';
import HttpCall from '../api/Http';
import SerializeClass from '../shared/Utils/serialized';
import Loader from '../shared/components/Loader';
import Alert from '../shared/Utils/AlertBox';

export default function UserDetail() {

  const user = JSON.parse(localStorage.getItem('user'))
  const [inputValue, setInputValue] = useState({ first_name: user[0].First_Name, last_name: user[0].Last_Name, phone: user[0].Phone_Number, company_name: user[0].company_name, password: "", new_password: "", confirm_password: "" });
  const [loader, setLoader] = useState(false);
  const { first_name, last_name, phone, company_name, password, new_password, confirm_password } = inputValue;


  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputValue((prev) => ({ ...prev, [name]: value, }));
  };

  function updateUserProfile(e) {
    e.preventDefault();
    let arr = [];
    let requestData = new FormData();

    arr.push({ P_User_Id: user[0].Id });
    arr.push({ P_First_Name: first_name });
    arr.push({ P_Last_Name: last_name });
    arr.push({ P_Phone_Number: phone });
    arr.push({ P_company_name: company_name });
    arr.push({ P_token: user[0].token });

    let p = SerializeClass.getSerializedData(arr);

    requestData.append('Params', p);

    let url = '/api/user/updateUserProfile';
    setLoader(true)
    HttpCall.postRequest2(url, requestData).then(response => {
      setLoader(false)
      if (response.data.code == 200) {
        let userData = response.data.data;
        if (userData.length > 0) {
          localStorage.setItem('user', JSON.stringify(userData));
        }


        Alert.show("Success!", "Porfile Updated Successfully.", "success");
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
      setLoader(false)
    })
  }

  function updateUserPassword(e) {
    e.preventDefault();

    if (new_password.length < 5) {
      Alert.show("Error!", "Password length must be atleast 5 characters", "error");
      return;
    }

    if (new_password != confirm_password) {
      Alert.show("Error!", "Passwords did not match", "error");
      return;
    }

    let arr = [];
    let requestData = new FormData();

    arr.push({ P_User_Id: user[0].Id });
    arr.push({ P_Password: password });
    arr.push({ P_New_Password: new_password });
    arr.push({ P_Confirm_Password: confirm_password });

    let p = SerializeClass.getSerializedData(arr);

    requestData.append('Params', p);

    let url = '/api/user/updateUserPassword';
    setLoader(true)
    HttpCall.postRequest2(url, requestData).then(response => {
      setLoader(false)
      if (response.data.code == 200) {
        Alert.show("Success!", "Password Updated Successfully.", "success");
      } else {
        Alert.show("Error!", response.data.msg, "error");
      }
    }).catch(err => {
      console.log(err);
      setLoader(false)
    })
  }

  return (
    <>
      <DashboardHeader />
      {loader && <Loader />}
      <div className="container-fluid page-body-wrapper">
        <SideMenu />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="row">
              <div className="col-md-6 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">My Profile</h4>
                    <p className="card-description">
                      Note: You can change or edited your details!
                    </p>

                    <form className="forms-sample">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">First Name</label>
                        <input type="text" className="form-control form-control-lg"
                          onChange={handleChange}
                          name="fiest_name"
                          value={first_name} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Last Name</label>
                        <input type="text" className="form-control form-control-lg"
                          onChange={handleChange}
                          name="last_name"
                          value={last_name} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email address</label>
                        <input disabled type="email" className="form-control form-control-lg" defaultValue={user[0].Email} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Phone Number</label>
                        <input type="tel" className="form-control form-control-lg"
                          onChange={handleChange}
                          name="phone"
                          value={phone} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Firm/Company Name</label>
                        <input type="text" className="form-control form-control-lg"
                          onChange={handleChange}
                          name="company_name"
                          value={company_name} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Current Subscription</label>
                        <input disabled type="text" className="form-control form-control-lg" defaultValue={user[0].plan_name} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Expiry Date</label>
                        <input disabled type="text" className="form-control form-control-lg" defaultValue={user[0].end_date} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Subscription Status</label>
                        <input disabled type="tel" className="form-control form-control-lg" defaultValue={user[0].is_active} />
                      </div>

                      <button type="submit" onClick={updateUserProfile} className="btn btn-primary me-2 savebtn">Save Details</button>
                    </form>
                  </div>
                </div>
              </div>
              <div className="col-md-6 grid-margin stretch-card">
                <div className="card">
                  <div className="card-body">
                    <h4 className="card-title">Security settings</h4>
                    <p className="card-description">
                      Note: You can change your current password!
                    </p>
                    <form className="forms-sample">

                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Current Password</label>
                        <input type="password" className="form-control form-control-lg" placeholder="*********"
                          onChange={handleChange}
                          name="password"
                          value={password} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">New Password</label>
                        <input type="password" className="form-control form-control-lg" placeholder="*********"
                          onChange={handleChange}
                          name="new_password"
                          value={new_password} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="exampleInputPassword1">Confirm Password</label>
                        <input type="password" className="form-control form-control-lg" placeholder="*********"
                          onChange={handleChange}
                          name="confirm_password"
                          value={confirm_password} />
                      </div>

                      <button type="submit" onClick={updateUserPassword} className="btn btn-primary me-2 savebtn">Save Password</button>
                    </form>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  )
}